import React from 'react'

export default function Resume() {
  return (
    <section id="resume" className="resume">
      <div className="container">

        <div className="section-title">
          <h2>Resume</h2>
          <p>Check My Resume</p>
        </div>

        <div className="row">
          <div className="col-lg-6">
            <h3 className="resume-title">Sumary</h3>
            <div className="resume-item pb-0">
              <h4>Kelechi Mbawuike</h4>
              <p><em>Innovative Front End Developer with 4 years experience building and maintaining responsive websites,
                web and mobile applications in the financial, health-care and accounting industries.</em>
              </p>
              <section>
                <ul>
                  <li>Lagos, Nigeria</li>
                  <li>(+234) 706-134-1943</li>
                  <li>kmbawuike@gmail.com</li>
                </ul>
              </section>
            </div>

            <h3 className="resume-title">Certifications</h3>
            <div className="resume-item">
              <h4>Bachelor of Technology</h4>
              <h5>2012 - 2017</h5>
              <p><em>Federal University of Technology Owerri, Imo, Nigeria</em></p>
              <p>Member National Association of Information Technology Students (NAITS), Rotaract club
                of Federal University of Technology Owerri (ROTAFUTO), Nigeria Federation of Catholic Students (NFCS) FUTO
                Chapter.</p>
            </div>
            <div className="resume-item">
              <h4>Microsoft Certified: Azure Fundamentals</h4>
              <h5>2019</h5>
              <p><em>Microsoft</em></p>
              <p>
                The certification validates your basic knowledge of cloud services and how those services are provided
                with Azure. Candidates should be able to demonstrate a fundamental knowledge of cloud concepts, along with
                Azure services, workloads, security, privacy, pricing, and support.
              </p>
            </div>
          </div>
          <div className="col-lg-6">
            <h3 className="resume-title">Professional Experience</h3>
            <div className="resume-item">
              <h4>Frontend Engineer</h4>
              <h5>2021 - Present</h5>
              <p><em>FCMB, Lagos, Nigeria </em></p>
              <section>
                <ul>
                  <li>Determining the structure and design of web pages.</li>
                  <li>Ensuring user experience determines design choices.
                  </li>
                  <li>Developing features to enhance the user experience.</li>
                  <li>Ensuring web design is optimized for smartphones.</li>
                </ul>
              </section>
            </div>
            <div className="resume-item">
              <h4>Frontend Engineer (Web & Mobile)</h4>
              <h5>2020 - 2021</h5>
              <p><em>Stransact Partners & Audit, Lagos, Nigeria</em></p>
              <section>
                <ul>
                  <li>Responsible for creating efficient design and developing User Interaction screens / SPA using HTML5,
                    CSS3, JavaScript React.JS and Bootstrap.</li>
                  <li>Built pixel-perfect, buttery smooth UIs across both mobile platforms (IOS & Andriod).</li>
                  <li>Leveraged native APIs for deep integrations with both platforms.</li>
                  <li>Developed and implemented highly responsive user interface components using react concepts.</li>
                </ul>
              </section>
            </div>
          </div>
        </div>

        <div className="d-flex justify-content-center mt-4">
          <a href="https://docs.google.com/document/d/1cS1wJo2og9w37vyKJNe7iLb1J7bGJ5YOLI2gVy4yp5U/edit?usp=sharing"
            className="btn main-bg" target="_blank" rel='noreferrer'>Download</a>
        </div>
      </div>
    </section>
  )
}
